import { getApiURL, getSessionId } from 'utils/utils';
import axios from 'axios';

const instance = axios.create({
  // baseURL: 'http://localhost:9781',
  baseURL: getApiURL(),
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

// body('question').isString().notEmpty(),
// body('moduleType').isIn(Object.values(MODULE_TYPE)),
// body('version').isIn(Object.keys(prompts.questionImprovement)).optional(),
export const generateImprovedQuestion = (params) =>
  instance.post(`/web-app/admin/ai/improve-question`, params, {
    headers: {
      sessionId: getSessionId(),
    },
  });
